import type { TFunction } from "i18next";
import type { ProjectedHumanStep, RequestAudience } from "../../../api/threads/liveMessages";
import { refusalText } from "../../../ui/feedback/refusalWords";
import type { ViewerRefusal } from "../page/viewerActions";

/**
 * Whom the waiting person step waits for (W-22 slice 1): module C names the request's audience, the web only words it.
 * For a viewer who can't answer, why not comes first where that is the reason (a closed Run, no permission to write).
 * `hostName` is `null` when the viewer hosts the Run.
 */
export function requestWaitText(step: ProjectedHumanStep, refusal: ViewerRefusal | null, hostName: string | null, t: TFunction): string {
  if (refusal === "closed" || refusal === "missing_permission") return refusalText(t, refusal);
  if (step.audience === "host") return hostName === null ? t("threads.waits.yours") : t("threads.waits.host", { name: hostName });
  return t(WAITS_FOR[step.audience]);
}

/** The open request after the Run left its Workflow: module C keeps it open (W22-D2, provisional), and no step shows it until the host resumes the Workflow. */
export function workflowLeftText(hostName: string | null, t: TFunction): string {
  return hostName === null ? t("threads.waits.workflowLeftHost") : t("threads.waits.workflowLeft", { name: hostName });
}

const WAITS_FOR: Readonly<Record<Exclude<RequestAudience, "host">, string>> = {
  participants: "threads.waits.participants",
  change_set_curators: "threads.waits.changeSetCurators",
  result_curators: "threads.waits.resultCurators",
  memory_owner: "threads.waits.memoryOwner",
};
